import dayjs from 'dayjs';
import { Enlistment } from 'models/user';

export const sortEnlistments = (patientGroups?: Enlistment[]) => {
  if (!patientGroups) return [];
  return patientGroups.sort(
    (groupA, groupB) =>
      parseFloat(dayjs(groupB.expiryTimestamp).unix().toString()) -
      parseFloat(dayjs(groupA.expiryTimestamp).unix().toString()),
  );
};
